








































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import QErrors from "@/common/qErrors.vue";
import StepCheckList from "@/components/contract-moving/step/stepCheckList.vue";
import ContractMoveOutHistory from "@/components/contract-moving/contractMoveOutHistory.vue";
import { namespace } from "vuex-class";
import ContractMoveOut from "@/model/contractMoveOut";
import _ from "lodash";
import { USER_ROLE } from "@/model/user";
import Company from "@/model/company";
import QUserSelect from "@/common/qUserSelect.vue";
import QCalendar from "@/common/qCalendar.vue";
import ReportRepair from "@/components/contract-moving/reportRepair.vue";
import qNotify from "@/common/qNotify";
import fileApi from "@/api/fileApi";
import {compareWithKeys} from "@/common/utils";

const moveOutStore = namespace("MoveOut");
const auth = namespace("Auth");
const routerStore = namespace("Router");
@Component({
  name: "StepCorrectCheckList",
  components: {
    StepCheckList,
    QErrors,
    ContractMoveOutHistory,
    QUserSelect,
    QCalendar,
    ReportRepair,
  },
})
export default class StepCorrectCheckList extends Vue {
  @moveOutStore.Getter
  getMoveOut!: ContractMoveOut;
  @auth.Getter
  getCurrentyCompany!: Company;
  @routerStore.Getter
  public getSearchParameters!:any;

  public moveOutObject: ContractMoveOut = new ContractMoveOut();
  public moveOutObjectInit: ContractMoveOut = new ContractMoveOut();
  public errors = {};
  public userRole = USER_ROLE;
  public dateConfig = {};
  public isShowSavePopup = false;
  public isShowApprovalPopup = false;

  mounted() {
    this.dateConfig = {
      minDate: new Date(),
    };
    this.moveOutObject = new ContractMoveOut(_.cloneDeep(this.getMoveOut));

    if (!this.moveOutObject.report_in_charge_id) {
      this.moveOutObject.report_in_charge_id = this.moveOutObject.witness_owner_id;
    }
    this.moveOutObjectInit = _.cloneDeep(this.moveOutObject)
  }
  get companyId() {
    return this.getCurrentyCompany.id;
  }
  get contractMoveOutId() {
    return this.$router.currentRoute.params.id;
  }

  public async uploadImage() {
    const request = [];
    this.moveOutObject.repair_content.map((item) => {
      // console.log(this.$refs[item.id]);
      (this.$refs[item.id][0] as ReportRepair).exportImage();
      request.push(this.uploadImageSVG(item.svg_image));
    });
    const results = await Promise.all(request);

    results.map((result: any, index) => {
      if (result.meta.status == 200) {
        this.moveOutObject.repair_content[index].repair_image_id =
          result.data.id;
      }
    });
  }

  public async uploadImageSVG(file) {
    let formData = new FormData();
    formData.append("image", file);
    formData.append("image_type", "RepairContent");
    return await fileApi.uploadImage(formData);
  }

  public async save() {
    this.moveOutObject.is_resolved && (await this.uploadImage());

    const result = await this.moveOutObject.updateReport();

    if (result.meta.status != 200) {
      qNotify.error({
        text: this.$t(result.meta.message),
      });
      this.errors = result.meta.errors;
    } else {
      this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
    }
  }

  public async cancel() {
    const isChangedByReport = await this.isChangedWithChild();
    if (isChangedByReport || this.isChanged()) {
      this.$modal.showCancel({
        text: this.$t("cancel"),
        // we are passing callback method for our confirm button
        onConfirm: () => {
          this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
        },
      });
    } else {
      this.$router.push({ name: "admin.contract-moving" , query: this.getSearchParameters ? this.getSearchParameters.contractMovingList : null });
    }
  }

  public async isChangedWithChild() {
    if (this.moveOutObjectInit.repair_content.length > 0) {
      for (let key in this.moveOutObjectInit.repair_content) {
        if (this.moveOutObject.repair_content[key].before_repair.length !== this.moveOutObjectInit.repair_content[key].before_repair.length) {
          return true;
        } else if (this.moveOutObject.repair_content[key].after_repair.length !== this.moveOutObjectInit.repair_content[key].after_repair.length) {
          return true;
        }
        const isChange = compareWithKeys(this.moveOutObject.repair_content[key], this.moveOutObjectInit.repair_content[key], [
          'remarks',
        ]);
        if (!isChange) {
          continue
        }
        return true;
      }
      return false;
    }
  }

  public isChanged() {
    return compareWithKeys(this.moveOutObject, this.moveOutObjectInit, [
      'report_in_charge_id',
      'report_repair_date',
      'billing_method',
      'breakdown_offset',
      'report_remarks',
    ])
  }
}
